<template>
    <div class="ix-formbuilder-component-summary-content">
        
        <div class="formbuilder-component boxed padding" v-if="displayMode == 'readable' || displayMode == 'fillable'">
            <div class="mb-small">
                <p class="formbuilder-component-label">{{ currentField.label }}</p>
                <p class="formbuilder-component-help" v-if="currentField.helper">{{ currentField.helper }}</p>
            </div>


            <table class="formbuilder-table mb-small">
                    <thead>
                        <th style="width: 225px;">&nbsp;</th>
                        <th v-for="(label,l) in currentField.labels" :key="l" class="text-center" style="width: 20px;">
                            {{ label[0] }}
                        </th>
                        <th v-if="currentField.displayObservation">Observations</th>
                    </thead>
                    <tbody v-for="(elements,row) in currentField.grid" :key="row">
                        <tr v-if="elements.title && elements.title.length">
                            <td v-bind:style="{textAlign : elements.textAlign, backgroundColor : elements.background, borderColor: elements.borderColor, color : elements.color}" :colspan="currentField.colspan">
                                {{ elements.title }}
                            </td>
                        </tr>
                        <tr v-for="(question,rowQuestion) in elements.questions" :key="rowQuestion">
                            <th>{{ question.label }}</th>
                            <td v-for="(answer, i) in question.answers" :key="i" class="text-center">
                                    <span class="formbuilder-checkbox round" v-if="displayMode == 'readable'">
                                        <span class="tick" v-if="currentField.grid[row].questions[rowQuestion].value == answer">&#10004;</span>
                                    </span>
                                    <input type="radio" :value="answer" v-if="displayMode == 'fillable'"  v-model="currentField.grid[row].questions[rowQuestion].value">
                            </td>
                            <td v-if="currentField.displayObservation">
                                <span  v-if="displayMode == 'readable'">{{ currentField.grid[row].questions[rowQuestion].observations }}</span>
                                <input type="text" class="form-control" v-if="displayMode == 'fillable'" v-model="currentField.grid[row].questions[rowQuestion].observations">
                            </td>
                        </tr>
                    </tbody>
            </table>

            <span v-for="(label,index) in currentField.labels" :key="index">
                {{ label[0] }} : {{ label }} <span v-if="index != (currentField.labels.length - 1)">-</span>
            </span>
        </div>

        <div v-if="displayMode == 'summary'" class="ix-formbuilder-component-summary-info">
            <div class="ix-formbuilder-component-summary-handle">
                <span class="ix-drag-icon handle-line"></span>
            </div>
            <div class="ix-formbuilder-component-summary-icon" data-toggle="tooltip" data-placement="top" title="Questionnaire">
                <div class="ix-formbuilder-icon">
                    <i class="far fa-question"></i>
                </div>
            </div>
            <div class="ix-formbuilder-component-summary-content">
                <span class="ix-formbuilder-component-summary-label">{{ currentField.label }}</span>
                <span class="ix-formbuilder-component-summary-help" v-if="currentField.helper">{{ currentField.helper }}</span>
                <ul class="ix-formbuilder-component-summary-options">
                    <li>{{ currentField.labels.length }} réponse{{ currentField.labels.length > 1 ? 's' : '' }}</li>
                    <li>{{ currentField.grid.length }} thématique{{ currentField.grid.length > 1 ? 's' : '' }}</li>
                    <li>Observations : {{ currentField.displayObservation ? 'activées' : 'désactivées' }}</li>
                </ul>
            </div>
        </div>

    </div>
</template>

<script>
    export default {
        name: "QuizzComponent",
        props: ['currentField','showIcon','displayMode'],
        methods : {
            getNumberThematic(){
                let number = 0;
                if(this.currentField.grid){
                    this.currentField.grid.forEach(items => {
                        if(items.isTitle)
                            number++
                    })
                }
                return number;
            },
            getNumberQuestions(){
                let number = 0;
                if(this.currentField.grid){
                    this.currentField.grid.forEach(items => {
                        if(!items.isTitle)
                            number += items.questions.length
                    })
                }
                return number;
            }
        }
    }
</script>
